import ReportsContainer from './containers/ReportsContainer';
export default ReportsContainer;
